import BasicApplication from "./Basic.application";

import {
    validationControlCurrentRequest,
} from "../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";
import { inputValidationInArray } from "../../redux/actions/Requests/currentRequestControls/inputValidationInArray";
import { attachmentsValidation } from "../../redux/actions/Requests/currentRequestControls/attachmentsValidation";

class ParentalLeaveApplication extends BasicApplication {
    constructor(options) {
        super(options);
        this.category = 1;
        this.tabs = options.tabs;
        this.relativeId = options.relativeId;
        this.isSingleParent = options.isSingleParent;
        this.parentsAlrosaStatusId = options.parentsAlrosaStatusId;
        this.cardNumber = options.cardNumber;
        this.accountNumber = options.accountNumber;
        this.bik = options.bik;
        this.passportSeries = options.passportSeries;
        this.passportNumber = options.passportNumber;
        this.parents = options.parents;
        this.children = options.children;
        this.employeeComment = options.employeeComment;
        this.dateTo = options.dateTo;
        this.dateFrom = options.dateFrom;
        this.actualAddress = options.actualAddress;
        this.registrationAddress = options.registrationAddress;
        this.isValid = {
            parents: [],
            children: [],
            actualAddress: true,
            registrationAddress: true,
            relativeId: true,
            isSingleParent: true,
            parentsAlrosaStatusId: true,
            cardNumber: true,
            accountNumber: true,
            bik: true,
            pasportSeria: true,
            pasportNumber: true,
            dateTo: true,
            dateFrom: true,
        };
    }

    static sendToValidation(currentRequest, dispatch) {
        const periodsCheck = true;
        const keysToCheck = {
            // eslint-disable-next-line max-len
            1: ["relativeId", "isSingleParent", "cardNumber", "accountNumber", "bik",
                "dateTo", "dateFrom"],
        };
        let generalResult = 0;
        let childResult = 0;

        if(currentRequest.isSingleParent === false) {
            if (currentRequest.parentsAlrosaStatusId === null || currentRequest.parentsAlrosaStatusId === undefined) {
                generalResult += 1;
                dispatch(validationControlCurrentRequest("parentsAlrosaStatusId", false));
            }
        }
        currentRequest.parents &&
        currentRequest.parents.forEach((element, index) => {
            if (currentRequest.parentsAlrosaStatusId !== 2) {
                if (!element.fullName) {
                    generalResult += 1;
                    dispatch(
                        inputValidationInArray({
                            fieldElement: "fullNameValid",
                            bool: true,
                            indexArray: index,
                            arrayField: "parents",
                        }),
                    );

                }
                if (!element.tabNumber) {
                    generalResult += 1;

                    dispatch(
                        inputValidationInArray({
                            fieldElement: "tabNumberValid",
                            bool: true,
                            indexArray: index,
                            arrayField: "parents",
                        }),
                    );
                }
            }


        });

        if (currentRequest.parentsAlrosaStatusId === 2 ) {
            if(currentRequest &&
                currentRequest.attachments ) {
                if(!currentRequest.attachments.length) {
                    console.log("TRUE");
                    generalResult += 1;
                    dispatch(validationControlCurrentRequest("attachNotValid", false));
                } else if (!currentRequest.attachments.filter(
                    (el) => (el.subDocumentType === 8) || (el.type === 8)
                ).length) {
                    generalResult += 1;
                    dispatch(validationControlCurrentRequest("attachNotValid", false));
                }
            }
        }



        currentRequest.children &&
        currentRequest.children.forEach((element, index) => {

            if (!element.birthDate) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "birthDateValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            if (!element.firstName) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "firstNameValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            if (!element.lastName) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "lastNameValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            // if (!element.middleName) {
            //     dispatch(
            //         inputValidationInArray({
            //             fieldElement: "middleNameValid",
            //             bool: true,
            //             indexArray: index,
            //             arrayField: "children",
            //         }),
            //     );
            // }
            if (!element.genderId) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "genderIdValid",
                        bool: false,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            if (!element.birthCertificateNumber) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "birthCertificateNumberValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            if (!element.birthCertificateDate) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "birthCertificateDateValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            if (!element.snils) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "snilsValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            if (!element.orderId) {
                // childResult += 1;
                dispatch(
                    inputValidationInArray({
                        fieldElement: "orderIdValid",
                        bool: false,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
            if (element.attachments && !element.attachments[0] || !element.attachments[0].uid) {
                childResult += 1;
                // dispatch(attachmentsValidation({
                //     arrIndex: index,
                //     attachIndex: 0,
                //     falsyAttach: true,
                //     calledArray: "attachments",
                //     fieldValidation: "attachValidation",
                //     arrayName: "children",
                // }));
                dispatch(
                    inputValidationInArray({
                        fieldElement: "birthAttach",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
                dispatch(
                    inputValidationInArray({
                        fieldElement: "childValid",
                        bool: true,
                        indexArray: index,
                        arrayField: "children",
                    }),
                );
            }
        });
        console.log(( !currentRequest.children || currentRequest.children.length === 0), currentRequest.children.length, currentRequest.children);
        if( !currentRequest.children || currentRequest.children.length === 0) {
            childResult += 1;
        }

        return (
            this.keyChecker(
                keysToCheck[1],
                currentRequest,
                dispatch,
                generalResult,
                childResult
            ) && periodsCheck
        );
    }

    static keyChecker(arrayOfKeys, currentRequest, dispatch, generalResult, childResult) {
        let result = 0;
        arrayOfKeys.forEach((e) => {
            if (
                !Array.isArray(e) &&
                (currentRequest[`${e}`] === null ||
                    currentRequest[`${e}`] === undefined ||
                     currentRequest[`${e}`] === ""

                )
            ) {
                result += 1;
                generalResult += 1;
                dispatch(validationControlCurrentRequest(e, false));
            } else if (Array.isArray(e)) {
                const key = [...e].shift();
                for (const bloodKey in currentRequest[key]) {
                    if (
                        currentRequest[key][bloodKey] === null ||
                        currentRequest[key][bloodKey] === undefined
                    ) {
                        result += 1;
                        dispatch(
                            validationControlCurrentRequest(
                                { object: key, innerKey: bloodKey },
                                false,
                                "object",
                            ),
                        );
                    }
                }
            }
        });
        if(generalResult !== 0) {
            console.log(generalResult);
            result += 1;
            dispatch(validationControlCurrentRequest("generalResult", false));
        }
        if(childResult !== 0) {
            console.log(childResult);
            result += 1;
            dispatch(validationControlCurrentRequest("childResult", false));
        }
        return !result;
    //     {
    //         result: !result,
    //         generalResult: result,
    //         childResult: childResult,
    // };
    }
}

export default ParentalLeaveApplication;
